<template>
    <main>
        <SliceZone :slices="slices" :components="components" />
    </main>
</template>

<script setup lang="ts">
    import {inject} from 'vue';
    import {SliceZone} from '@prismicio/vue';
    import {useAsyncData} from '#app';
    import {useHead, definePageMeta, useWebsitePageView, createError} from '#imports';
    import {usePrismicDocument} from '~/composables/content/usePrismicDocument';
    import {usePrismicPage} from '~/composables/content/usePrismicPage';
    import type {MicrodataRecord} from '~/composables/microdataFormatter';
    import {microdataFormatter} from '~/composables/microdataFormatter';
    import {HOST_SETTINGS} from '~/keys';
    import {components} from '~/slices/components';

    const hostSetting = inject(HOST_SETTINGS);
    const microData = microdataFormatter().formatMicrodata(hostSetting);

    const {fetchDocument} = usePrismicDocument('homepage');
    const {data, error} = await useAsyncData('homepage', () => fetchDocument());
    if (error.value) {
        throw createError(error.value);
    }

    const {slices} = usePrismicPage(data.value!, {head: true});

    if (microData) {
        useHead({
            script: microData.map(microdataToScript),
        });
    }

    function microdataToScript(record: MicrodataRecord) {
        return {
            type: 'application/ld+json' as const,
            innerHTML: JSON.stringify(record, null, 2),
        };
    }

    definePageMeta({
        middleware: 'redirect-to-home',
    });

    useWebsitePageView('cms', 'homepage');
</script>
